import styled from "styled-components";
import FormSimpleSelect from "@src/Components/Common/FormFields/FormSimpleSelect/FormSimpleSelect";
import { Grid } from "@material-ui/core";

export const STMainWrapper = styled.div`
  && {    
    width: 100%
  }
`;

export const STGrid = styled(Grid)`
  && {    
    padding-right: 2em;
  }
`;

export const STSelectLocationWrapper = styled.div`
{
    overflow: hidden;
    width: 100%;
    .select {
        text-overflow: ellipsis;
        display: block !important;
        white-space: nowrap;
        overflow: hidden;
        width: auto;
    }
  }
`;

export const STFormSimpleSelect = styled(FormSimpleSelect).attrs({
  classes: { root: "root" },
})`
  && {
    .root {
      min-width: 150px;
    }
  }
`;